import { Person } from 'fobclient/lib/entity'
import Organisationseinheit from './Organisationseinheit'
import PersonIdent from '@/schema/PersonIdent'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Person')

export default {
  label: 'Interne Person',
  route: 'person',
  class: Person,
  className: 'person',
  fields: [
    Fields.String('vorname'),
    Fields.String('name'),
    Fields.String('titel'),
    Fields.String('fisPersid'),
    PersonIdent,
    {
      label: 'Person.form.organisationseinheiten',
      field: 'organisationseinheiten',
      type: 'object',
      cardinality: 'many',
      schema: Organisationseinheit,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Person.js